import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopShippingMethodFragment = { __typename: 'ShopShippingMethodObject', id: number, isCollection: boolean, name: string, description?: string | null | undefined };

export type ShopShippingMethodsQueryVariables = Types.Exact<{
  channelCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  collection?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ShopShippingMethodsQuery = { __typename: 'Query', shopShippingMethods: Array<{ __typename: 'ShopShippingMethodObject', id: number, isCollection: boolean, name: string, description?: string | null | undefined }> };

export type ShopShippingMethodsWithCollectionsQueryVariables = Types.Exact<{
  orderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopShippingMethodsWithCollectionsQuery = { __typename: 'Query', shopShippingMethods: Array<{ __typename: 'ShopShippingMethodObject', isCollection: boolean }> };

export type ShopShippingMethodQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ShopShippingMethodQuery = { __typename: 'Query', shopShippingMethod: { __typename: 'ShopShippingMethodObject', id: number, isCollection: boolean, name: string, description?: string | null | undefined } };

export const ShopShippingMethodFragmentDoc = gql`
    fragment ShopShippingMethod on ShopShippingMethodObject {
  id
  isCollection
  name
  description
}
    `;
export const ShopShippingMethodsDocument = gql`
    query ShopShippingMethods($channelCode: String, $orderId: Int, $collection: Boolean) {
  shopShippingMethods(
    orderId: $orderId
    collection: $collection
    channelCode: $channelCode
  ) {
    ...ShopShippingMethod
  }
}
    ${ShopShippingMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopShippingMethodsGQL extends Apollo.Query<ShopShippingMethodsQuery, ShopShippingMethodsQueryVariables> {
    document = ShopShippingMethodsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopShippingMethodsWithCollectionsDocument = gql`
    query ShopShippingMethodsWithCollections($orderId: Int) {
  shopShippingMethods(orderId: $orderId, collection: true) {
    isCollection
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopShippingMethodsWithCollectionsGQL extends Apollo.Query<ShopShippingMethodsWithCollectionsQuery, ShopShippingMethodsWithCollectionsQueryVariables> {
    document = ShopShippingMethodsWithCollectionsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopShippingMethodDocument = gql`
    query ShopShippingMethod($id: Int!) {
  shopShippingMethod(id: $id) {
    ...ShopShippingMethod
  }
}
    ${ShopShippingMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopShippingMethodGQL extends Apollo.Query<ShopShippingMethodQuery, ShopShippingMethodQueryVariables> {
    document = ShopShippingMethodDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }